import React, { FC } from 'react';
import { useHistory } from 'react-router';

import { Modal } from 'app/design-system/components/Modal';
import { useTranslation } from 'app/lang';

import PromocodeForm from '../PromocodeForm';

import dictionary from './PromocodeModal.dictionary.json';

import styles from './PromocodeModal.module.scss';

export const PROMOCODE_MODAL_PARAM_KEY = 'promocode';

export const PromocodeModal: FC = () => {
  const { location, replace } = useHistory();
  const { t } = useTranslation();

  const urlParams = new URLSearchParams(location.search);
  const isOpen = urlParams.has(PROMOCODE_MODAL_PARAM_KEY);

  const onClose = () => replace({ search: '' });

  return (
    <Modal isOpen={isOpen}
           onClose={onClose}
           maxWidth={536}>
      <Modal.Header>
        {t(dictionary.title)}
      </Modal.Header>
      <Modal.Body className={styles.content}>
        {t(dictionary.description)}
        <PromocodeForm />
      </Modal.Body>
    </Modal>
  );
};
